<template>
  <div style="height: 100%;">
    <v-container class="center-content" fill-height grid-list-lg>
      <v-col align="center" class="fill-hight">
        <v-col>
          <v-img alt="Cellsmart Logo" class="shrink mr-2" contain src="@/assets/fullLogo.png"
            transition="scale-transition" width="250" />
        </v-col>
        <v-col>
          <div class="font-weight-bold title">Welcome</div>
        </v-col>
        <!-- stage: {{ stage }} -->
        <v-col md="6">
          <div v-if="stage === 1">
            <v-card flat class="outlined">
              <v-card-text>
                <h3>Organization</h3>
                <h4 class="my-3 font-weight-regular text-center" style="text-align: justify;">
                  Please provide your organization's information. All of your data will be securely stored under this
                  organization, regardless of whether you have one or multiple business locations.
                </h4>
                <v-text-field :background-color="`${Organization.name ? false : '#cef2f6'}`" label="Organization Name"
                  v-model="Organization.name" outlined dense :error-messages="organizationNameErrors"></v-text-field>
                <v-text-field type="number" :background-color="`${Organization.phoneNumber ? false : '#cef2f6'
                  }`" v-model="Organization.phoneNumber" label="Phone number" outlined dense
                  :error-messages="organizationPhoneNumberErrors"
                  hint="ie. Headquater Office Number, Owners phone number, etc" mask="phone">
                </v-text-field>

                <v-text-field :background-color="`${Organization.email ? false : '#cef2f6'}`" v-model="Organization.email"
                  outlined dense label="Email" :error-messages="organizationEmailErrors"
                  hint="This email will receive information about all business under this Organization.">
                </v-text-field>
                <!-- <v-layout>
              <v-spacer></v-spacer>
              <v-btn
                data-cy="newOrganizationContinueBtn"
                large
                class="white-btn v-btn-with-radius"
                :disabled="$v.Organization.$invalid"
                @click="nextStage"
                >continue</v-btn
              >
            </v-layout> -->
              </v-card-text>
            </v-card>
          </div>

          <div v-if="stage === 2">
            <v-card flat class="outlined">
              <v-container>
                <h3>Your first location</h3>
                <p class="text-caption mt-1 text-center" style="text-align: justify;">
                  Kindly provide the business information
                  for your initial location or primary storefront that you intend
                  to launch. If you're enrolling multiple locations, please start by
                  entering the details of the location you regard as your main business
                  hub. You'll have the opportunity to input additional locations once your
                  organizational setup is finalized. This information will be prominently
                  showcased on your time clock devices, ensuring accurate identification.
                  <!-- <b>This information will be printed on the business invoice
                    receipts.</b> -->
                </p>

                <v-text-field outlined dense :background-color="`${Location.name ? false : '#cef2f6'}`"
                  v-model="Location.name" label="Business Name" :error-messages="locationNameErrors">
                </v-text-field>

                <v-text-field outlined dense :background-color="`${Location.email ? false : '#cef2f6'}`"
                  v-model="Location.email" label="Email Address" :error-messages="locationEmailErrors">
                </v-text-field>


                <h4>Address</h4>

                <v-layout row wrap>
                  <!-- <v-flex xs12 sm6 md6>
                    <v-text-field type="text" outlined dense v-model="Location.Address.type"
                      @focus="$event.target.select()" label="Type" hint="ie. Home, Office, Business"></v-text-field>
                  </v-flex> -->

                  <v-flex xs12 sm6 md6>
                    <v-text-field type="text" outlined dense v-model="Location.Address.phoneNumber"
                      @focus="$event.target.select()" label="Phone Number"></v-text-field>
                  </v-flex>

                  <v-flex xs12 sm6 md6>
                    <v-text-field type="text" outlined dense :background-color="`${Location.Address.addressLine1 ? false : '#cef2f6'
                      }`" v-model="Location.Address.addressLine1" :error-messages="addressLine1Errors"
                      data-cy="newOrganizationLocationAddressLine1" label="Address" @focus="$event.target.select()"
                      @input="$v.Location.Address.addressLine1.$touch()"></v-text-field>
                  </v-flex>

                  <!-- <v-flex xs12 sm6 md6>
                    <v-text-field type="text" outlined dense v-model="Location.Address.addressLine2"
                      @focus="$event.target.select()" data-cy="newOrganizationLocationAddressLine2"
                      label="Address Line 2"></v-text-field>
                  </v-flex> -->

                  <v-flex xs12 sm6 md6>
                    <v-text-field outlined dense :background-color="`${Location.Address.city ? false : '#cef2f6'
                      }`" type="text" v-model="Location.Address.city" :error-messages="cityErrors" label="City"
                      @focus="$event.target.select()" @input="$v.Location.Address.city.$touch()"></v-text-field>
                  </v-flex>

                  <v-flex xs12 sm6 md6>
                    <v-autocomplete outlined dense :background-color="`${Location.Address.StateId ? false : '#cef2f6'
                      }`" :items="states" label="State" :error-messages="stateIdErrors" item-text="name"
                      item-value="id" v-model="Location.Address.StateId"></v-autocomplete>
                  </v-flex>

                  <v-flex xs12 sm6 md6>
                    <v-text-field outlined dense :background-color="`${Location.Address.postalCode ? false : '#cef2f6'
                      }`" type="text" :error-messages="postalCodeErros" v-model="Location.Address.postalCode"
                      label="Zip Code"></v-text-field>
                  </v-flex>

                  <v-flex xs12 sm6 md6>
                    <v-autocomplete outlined dense :background-color="`${Location.Address.CountryCode ? false : '#cef2f6'
                      }`" :items="countries" :error-messages="countryCodeErrors" label="Country" item-text="name"
                      item-value="code" v-model="Location.Address.CountryCode"></v-autocomplete>
                  </v-flex>

                  <!-- <v-layout>
                <v-btn
                  large
                  class="white-btn v-btn-with-radius"
                  @click="prevStage"
                  >back</v-btn
                >
                <v-spacer></v-spacer>
                <v-btn
                  large
                  class="white-btn v-btn-with-radius"
                  :disabled="$v.Location.$invalid"
                  @click="nextStage"
                  >continue</v-btn
                >
              </v-layout> -->
                </v-layout>
              </v-container>
            </v-card>
          </div>

          <v-card flat class="outlined" v-if="stage === 3">
            <v-container>
              <div>
                <h2>Select the plan for your first business</h2>
                <div>Customize by adding Extras anytime</div>
                <div class="mb-3">No hidden fees, cancel any time</div>
                <h5>Plans</h5>
                <v-item-group mandatory v-model="planIndex">
                  <v-container>
                    <v-row justify="center">
                      <v-col v-for="(n, i) in plans" :key="i" cols="6" sm="4">
                        <v-item v-slot="{ active, toggle }">
                          <v-card :color="active ? 'primary' : ''" class="d-flex align-center" dark @click="toggle">
                            <v-card-text>
                              <div :class="active ? 'font-weight-bold' : ''" class="text-center white--text">
                                {{ n }}
                              </div>
                            </v-card-text>


                          </v-card>
                        </v-item>
                      </v-col>
                    </v-row>
                  </v-container>
                </v-item-group>
                <div class="text-center display-2">{{ plans[planIndex] }}</div>
                <v-list dense v-if="planIndex === 1">
                  <v-list-item v-for="item in stripePlans" v-if="item.recurring.interval === 'year'" :key="item.id">
                    <v-list-item-content class="pa-0 text-capitalize">
                      <v-list-item-title>
                        {{ item.metadata.package }} package</v-list-item-title>
                      <v-list-item-subtitle>{{ item.metadata.employeeCount }} attendee
                        {{ (item.unit_amount / 100) | currency }}
                        {{ item.recurring.interval }}</v-list-item-subtitle>
                    </v-list-item-content>
                    <v-list-item-action>
                      <v-card flat color="grey lighten-3" class="rounded-lg">
                        <v-card-text>
                          <v-layout row align-center>
                            <v-btn text icon :disabled="item.quantity === 0 ? true : false
                              " @click="minusQty(item)">
                              <v-icon small color="black">mdi-minus</v-icon>
                            </v-btn>
                            <div class="black--text px-2">
                              {{ item.quantity }}
                            </div>

                            <v-btn text icon @click="addQty(item)">
                              <v-icon small color="black">mdi-plus</v-icon>
                            </v-btn>
                          </v-layout>
                        </v-card-text>
                      </v-card>
                    </v-list-item-action>
                  </v-list-item>
                </v-list>

                <v-list dense v-else>
                  <v-list-item v-for="item in stripePlans" v-if="item.recurring.interval === 'month'" :key="item.id">
                    <v-list-item-content class="pa-0 text-capitalize">
                      <v-list-item-title>
                        {{ item.metadata.package }} package</v-list-item-title>
                      <v-list-item-subtitle>{{ item.metadata.employeeCount }} attendee
                        {{ (item.unit_amount / 100) | currency }}
                        {{ item.recurring.interval }}</v-list-item-subtitle>
                    </v-list-item-content>
                    <v-list-item-action>
                      <v-card flat color="grey lighten-3" class="rounded-lg">
                        <v-card-text>
                          <v-layout row align-center>
                            <v-btn text icon :disabled="item.quantity === 0 ? true : false
                              " @click="minusQty(item)">
                              <v-icon small color="black">mdi-minus</v-icon>
                            </v-btn>
                            <div class="black--text px-2">
                              {{ item.quantity }}
                            </div>

                            <v-btn text icon @click="addQty(item)">
                              <v-icon small color="black">mdi-plus</v-icon>
                            </v-btn>
                          </v-layout>
                        </v-card-text>
                      </v-card>
                    </v-list-item-action>
                  </v-list-item>
                </v-list>

                <!-- <v-radio-group v-model="items" :mandatory="false">
                <v-radio
                  v-for="item in plans"
                  :key="item.id"
                  v-if="item.id !== 3"
                  :label="item.name"
                  :value="item"
                ></v-radio>
              </v-radio-group> -->
                <!-- v-show="items && parseFloat(items.amount) > 0" -->
                <v-card flat transition="v-scale-transition" v-if="employeeCount > 0">
                  <v-card-text>
                    <v-layout column align-center justify-center>
                      <h4 class="my-2">Payment Method</h4>
                      <div class="text-center mb-2">
                        <strong>{{ employeeCount }}</strong> Employees
                        <strong>{{ (chargeAmount / 100) | currency }}</strong>
                        every <strong>{{ interval }}</strong>
                      </div>
                    </v-layout>
                  </v-card-text>
                </v-card>

                <v-card flat transition="v-scale-transition">
                  <v-card-text>
                    <v-layout column align-center justify-center>
                      <CollectCard @token="submit"></CollectCard>
                    </v-layout>
                  </v-card-text>
                </v-card>


                <v-flex class="ma-3">
                  <p class="text-caption" style="text-align: justify;">
                    Your 'On The Clock Now' subscription
                    will initiate upon clicking the 'Create Organization'
                    button. By proceeding with 'Create Organization,' you grant
                    us authorization to: (i) automatically commence and sustain your
                    month-to-month subscription, and (ii) periodically charge the subscription
                    fee to the payment method provided, unless cancelled. To cancel, kindly reach out to
                    us at info@ontheclocknow.com. Subscription fees are billed monthly in advance, and no
                    reimbursements or credits will be provided for partial or prepaid months post
                    cancellation. Please note that all prices, fees, charges, services, programming,
                    features, functionalities, and offers are subject to change without prior notice.
                  </p>
                  <p class="font-weight-bold">
                    By clicking, “Create, I confirm that I am over 13 and have
                    read the
                    <!-- <a href="https://www.cellsmartpos.com/termsandcondition/">Terms of Use</a>. -->
                  </p>
                </v-flex>
                <v-btn block color="primary" :disabled="employeeCount > 0 ? false : true" @click="getToken"
                  :loading="isLoading">Create</v-btn>
              </div>
              <!-- <div v-else>
              You're all set. Confirm the terms and condition to finalize your
              sign up.
            </div> -->
            </v-container>
          </v-card>
        </v-col>
      </v-col>

    </v-container>
    <v-footer app color="#F3F8FC">
      <v-row v-if="stage === 1">
        <v-spacer></v-spacer>
        <v-col class="text-right">
          <v-btn color="secondary" :dark="!$v.Organization.$invalid" :disabled="$v.Organization.$invalid"
            @click="nextStage">Continue</v-btn>
        </v-col>
      </v-row>

      <v-row v-if="stage === 2">
        <v-col class="text-left">
          <v-btn text @click="prevStage">Back</v-btn>
        </v-col>
        <v-spacer></v-spacer>
        <v-col class="text-right">
          <v-btn color="secondary" :dark="!$v.Location.$invalid" :disabled="$v.Location.$invalid"
            @click="nextStage">Continue</v-btn>
        </v-col>
      </v-row>


      <v-layout v-if="stage === 3">
        <v-btn text @click="prevStage">back</v-btn>
        <v-spacer></v-spacer>
        <v-btn color="secondary" text @click="cancelPressed">Cancel</v-btn>

        <v-btn color="primary" :disabled="employeeCount > 0 ? false : true" @click="getToken"
          :loading="isLoading">Create</v-btn>
      </v-layout>
    </v-footer>
  </div>
</template>
<script>
// import { Card, createToken } from "vue-stripe-elements-plus";
// import { StripeElements, StripeElement } from "vue-stripe-elements-plus";
// import { mapGetters, mapActions } from 'vuex'
import timezones from "compact-timezone-list";
import organizationService from "@/modules/BackOffice/service.js";
import publicService from "@/api/public";
import EventBus from '@/event-bus.js'

// import backofficeService from "@/modules/BackOffice/service.js";
import CollectCard from "@/components/CollectCard.vue"
const { validationMixin } = require("vuelidate");
const { required, minLength, email } = require("vuelidate/lib/validators");

export default {
  name: "new-organization",
  data() {
    return {
      employeeCount: 0,
      chargeAmount: 0,
      interval: "year",
      states: [],
      countries: [],
      stripePlanId: null,
      stripePlans: [],
      stage: 1,
      clientEmail: process.env.VUE_APP_CLIENT_EMAIL,
      clientName: process.env.VUE_APP_CLIENT_NAME,
      complete: false,
      // stripePublicKey: process.env.VUE_APP_STRIPE_PK,
      isLoading: false,
      ReferralCode: null,
      timeZones: timezones,
      // Organization: {
      //   name: "saqibNew org",
      //   phoneNumber: "7182992222",
      //   email: "saqib+24@cellsmartpos.com",
      //   cardToken: null,
      // },
      // Location: {
      //   name: 'saqib store new',
      //   type: "store",
      //   timeZone: this.$moment.tz.guess() || "America/New_York",
      //   email: 'saqib+24@cellsmartpos.com',
      //   Address: {
      //     name: "store",
      //     addressLine1: "1989 universtiy ave",
      //     addressLine2: null,
      //     addressLine3: null,
      //     city: "bronx",
      //     StateId: 39,
      //     CountryCode: 840,
      //     phoneNumber: "7182992222",
      //     postalCode: null
      //   },
      // },
      Organization: {
        name: null,
        phoneNumber: null,
        email: null,
        cardToken: null,
      },
      Location: {
        name: null,
        type: null,
        website: null,
        DCALicense: null,
        timeZone: this.$moment.tz.guess() || "America/New_York",
        email: null,
        Address: {
          name: null,
          addressLine1: null,
          addressLine2: null,
          addressLine3: null,
          city: null,
          StateId: null,
          CountryCode: 840,
          phoneNumber: null,
          postalCode: null
        },
      },
      plans: ["Monthly", "Yearly"],
      items: null,
      planIndex: 1,
    };
  },
  watch: {
    stage(val) {
      console.log('val of stage', val)
      if (val === 2) {
        console.log('Organization', this.Organization)
        console.log('Location', this.Location)
        this.Location.name = this.Organization.name
        this.Location.email = this.Organization.email
        this.Location.Address.phoneNumber = this.Organization.phoneNumber
      }
    },
    planIndex(val) {
      // this.items = this.plans[val];
      if (val === 0) {
        this.interval = "month";
      } else {
        this.interval = "year";
      }
      this.stripePlans.map((row) => {
        row.quantity = 0;
      });
      this.employeeCount = 0;
      this.chargeAmount = 0;
    },
  },
  components: {
    CollectCard
  },
  created() {
    console.log("this.$route.params", this.$route.params);
    if (this.$route.params && this.$route.params.email) {
      this.Organization.email = this.$route.params.email;
      // this.Location.Address = this.$route.params.email;
    }
    // publicService
    //   .GetPlans({ audience: "CUSTOMCLOCKIN" })
    //   .then((response) => {
    //     console.log("plans", response);
    //     this.stripePlanId = response.data[0].planId;
    //     this.getPriceList();
    //   });

    this.getPriceList();
    this.getState();
    this.getCountry();
    this.items = this.plans[this.planIndex];
    // publicService
    //   .GetPlans({ planId: this.$route.params.plan, includeIntegrations: true })
    //   .then(response => {
    //     this.plans = response.data
    //     if (this.$route.params.plan && response.data.length > 0) {
    //       this.Location.planId = this.$route.params.plan
    //       this.items = response.data[0]
    //     }
    //   })
  },
  methods: {
    // ...mapActions('global', ['initOrganization']),
    cancelPressed() {
      return this.$swal
        .fire({
          title: "Are you sure?",
          text: "You want to cancel creating new account",
          icon: "warning",
          showCancelButton: true,
          confirmButtonColor: "#3085d6",
          cancelButtonColor: "#d33",
          confirmButtonText: "Yes",
          cancelButtonText: "No",
        })
        .then((result) => {
          if (result.isConfirmed) {
            this.$router.push({ path: "/backoffice/login" });
          }
        })
        .catch((error) => {
          console.log(error);
        });
    },
    minusQty(row) {
      row.quantity--;
      this.updateEmployeeCount();
      this.$forceUpdate();
    },
    addQty(row) {
      row.quantity++;
      this.updateEmployeeCount();
      this.$forceUpdate();
    },
    updateEmployeeCount() {
      this.employeeCount = 0;
      this.chargeAmount = 0;
      this.items = []
      this.stripePlans.map((item) => {
        // console.log('item.quantity', item.employeeCount)
        this.employeeCount +=
          parseInt(item.quantity) * 
        parseInt(item.metadata.employeeCount);
        this.chargeAmount += parseInt(item.quantity) * item.unit_amount;
        if (item.quantity !== 0) {
          this.items.push(item)
        }
      });
    },
    getPriceList() {
      // console.log('process.env.', process.env.NODE_ENV)
      if (process.env.NODE_ENV === 'development') {
        this.stripePlanId = 'prod_OeRj9N1bJCpwbd'
      } else {
        this.stripePlanId = 'prod_Of83o9hyqfwHtI'
      }
      publicService
        .getPriceList({
          stripe: {
            product: this.stripePlanId,
            active: true,
          },
        })
        .then((response) => {
          console.log("price list", response.data);
          this.stripePlans = response.data.data;
          this.stripePlans.map((row) => {
            row.quantity = 0;
            // row.employeeCount = 0
          });
        })
        .catch((err) => {
          console.log(err);
          this.$toast.error(err.data ? err.data.message : "Error", {
            timeout: 2000,
          });
        });
    },
    getState() {
      return publicService.States().then((response) => {
        // console.log("responseresponse", response);
        this.states = response.data;
      });
    },
    getCountry() {
      return publicService.Country().then((response) => {
        // console.log("responseresponse", response);
        this.countries = response.data;
      });
    },
    prevStage() {
      this.stage--;
    },
    nextStage() {
      this.stage++;
    },
    getToken() {
      EventBus.$emit('get-card');
    },
    async submit(cardToken) {
      console.log('selected plan', this.$v)
      this.$v.$touch();
      if (this.$v.$invalid) {
        this.$toast.error("Invalid Input", {
          timeout: 2000,
        });
      }
      // else if (
      //   !this.complete &&
      //   this.items &&
      //   parseFloat(this.items.amount) > 0
      // ) {
      //   this.$toast.error("Card is required.", {
      //     timeout: 2000,
      //   });
      // }
      else {
        this.isLoading = true;
        // If card was added then we need to create the token before creating the organization
        // if (this.complete) {
        //   const data = await createToken();
        //   this.Organization.cardToken = data.token.id;
        // }

        // Check if plan was selected
        this.Location.planId = this.planId
        console.log('this.items', this.Location)

        this.Location.items = []
        await Promise.all(
          this.items.map(item => {
            this.Location.items.push({
              price: item.id,
              quantity: item.quantity
            })
          }))
        // const cardToken = await this.pay();
        // console.log("cardToken", cardToken);
        if (cardToken && cardToken.error) {
          this.$toast.error(
            cardToken.error ? cardToken.error.message : "Error",
            {
              timeout: 3000,
            }
          );
          this.isLoading = false;
          return;
        }

        this.Organization.cardToken = cardToken.token.id

        organizationService
          .create({
            ReferralCode: this.ReferralCode,
            Organization: this.Organization,
            Location: this.Location,
            cciUser: true
          })
          .then((response) => {
            this.isLoading = false;
            console.log("response", response.data);
            localStorage.setItem(`${process.env.VUE_APP_STORAGE_PREFIX}organizationId`, response.data.id)
            this.$router.push({ path: "/backoffice/login" });
            // this.$router.push({ path: "/backoffice/hardware", params: {location: this.Location}});
            // return this.initOrganization(response.data)
            //   .then(() => {
            //     this.$router.push({ path: "/" });
            //   })
            //   .catch((error) => {
            //     console.log(error);
            //   });
          })
          .catch((error) => {
            console.log(error);
            this.$toast.error(error.data.message, {
              position: "top-right",
              showHideTransition: "slide",
              icon: "error",
              duration: 4000,
            });
            this.isLoading = false;
          });
      }
    },
  },
  computed: {
    // ...mapGetters('global', ['states', 'countries', 'defaultCountryCode']),
    organizationNameErrors() {
      const errors = [];
      if (!this.$v.Organization.name.$dirty) return errors;
      if (!this.$v.Organization.name.required)
        errors.push('Field Is Required');
      if (!this.$v.Organization.name.minLength)
        errors.push(this.$t("validations.fieldMustbeatLeast4ChrLong"));
      return errors;
    },
    organizationPhoneNumberErrors() {
      const errors = [];
      if (!this.$v.Organization.phoneNumber.$dirty) return errors;
      if (!this.$v.Organization.phoneNumber.required)
        errors.push(this.$t("validations.phoneNumberIsRequired"));
      if (!this.$v.Organization.phoneNumber.minLength)
        errors.push(this.$t("validations.invalidPhoneNumber"));
      return errors;
    },
    organizationEmailErrors() {
      const errors = [];
      if (!this.$v.Organization.email.$dirty) return errors;
      if (!this.$v.Organization.email.required)
        errors.push('Field Is Required');
      if (!this.$v.Organization.email.email)
        errors.push(this.$t("validations.emailIsNotValid"));
      return errors;
    },
    locationNameErrors() {
      const errors = [];
      if (!this.$v.Location.name.$dirty) return errors;
      if (!this.$v.Location.name.required)
        errors.push('Field Is Required');
      if (!this.$v.Location.name.minLength)
        errors.push(this.$t("validations.fieldMustbeatLeast4ChrLong"));
      return errors;
    },
    locationEmailErrors() {
      const errors = [];
      if (!this.$v.Location.email.$dirty) return errors;
      if (!this.$v.Location.email.email)
        errors.push(this.$t("validations.emailIsNotValid"));
      return errors;
    },
    addressLine1Errors() {
      const errors = [];
      if (!this.$v.Location.Address.addressLine1.$dirty) return errors;
      if (!this.$v.Location.Address.addressLine1.minLength)
        errors.push('Address Must Have At Least 2 Characters');
      if (!this.$v.Location.Address.addressLine1.required)
        errors.push('Field Is Required');
      return errors;
    },
    cityErrors() {
      const errors = [];
      if (!this.$v.Location.Address.city.$dirty) return errors;
      if (!this.$v.Location.Address.city.required)
        errors.push('Field Is Required');
      return errors;
    },
    postalCodeErros() {
      const errors = [];
      if (!this.$v.Location.Address.postalCode.$dirty) return errors;
      if (!this.$v.Location.Address.postalCode.required)
        errors.push('Field Is Required');
      return errors;
    },
    stateIdErrors() {
      const errors = [];
      if (!this.$v.Location.Address.StateId.$dirty) return errors;
      if (!this.$v.Location.Address.StateId.required)
        errors.push('Field Is Required');
      return errors;
    },
    countryCodeErrors() {
      const errors = [];
      if (!this.$v.Location.Address.CountryCode.$dirty) return errors;
      if (!this.$v.Location.Address.CountryCode.required)
        errors.push('Field Is Required');
      return errors;
    },
  },
  mixins: [validationMixin],
  validations: {
    Organization: {
      name: {
        required,
        minLength: minLength(4),
      },
      phoneNumber: {
        required,
        minLength: minLength(10),
      },
      email: {
        required,
        email,
      },
    },
    Location: {
      name: {
        required,
        minLength: minLength(4),
      },
      email: {
        email,
      },
      Address: {
        addressLine1: {
          required,
          minLength: minLength(2),
        },
        city: {
          required,
        },
        postalCode: {
          required,
        },
        StateId: {
          required,
        },
        CountryCode: {
          required,
        },
      },
    },
  },
};
</script>
